<template>
  <div>
    <div v-if="loading" class="text-xs-center my-5 pt-5">
      <v-progress-circular :size="50" color="black" indeterminate/>
    </div>
    <div v-else>
      <v-container fluid grid-list-xxl px-0 py-0>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4 lg3 v-for="gallery in galleries" :key="gallery.id">
            <v-hover>
              <base-card
                slot-scope="{ hover }"
                color="secondary"
                :class="{'elevation-12 scale-down' : hover}"
                :to="{ name: 'galleries.single', params: {gallerySlug: gallery.slug }}"
              >
                <v-img
                  v-if="gallery.media"
                  position="center center"
                  height="250px"
                  sizes="250px"
                  :src="gallery.media.url"
                  :srcset="gallery.media.srcset"
                  :style="{'background-color': gallery.media.color }"
                />

                <v-card-title primary-title>
                  <div class="content-area">
                    <h3 class="heading name">{{ gallery.name }}</h3>
                  </div>
                </v-card-title>
              </base-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <div class="text-xs-right mt-4" v-if="galleries.length">
      <v-pagination
        @input="fetchData"
        :disabled="loading"
        :value="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="7"
      />
    </div>
  </div>
</template>

<script>
import { ErrorHandler } from "@/utils/ErrorHandler";
const handler = new ErrorHandler();

export default {
  created() {
    this.fetchData(1);
  },

  data() {
    return {
      loading: true,
      galleries: [],
      pagination: {}
    };
  },

  methods: {
    async fetchData(page) {
      this.loading = true;
      await handler.handle(async () => {
        const res = await this.$axios.get(
          `galleries?include=media&limit=12&page=${page}`
        );
        this.galleries = res.data["data"];
        this.pagination = res.data["meta"];
      });
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
h3.heading {
  font-size: 1.3rem !important;
}
.v-card {
  .content-area {
    max-height: 190px;
    overflow: hidden;
  }
  .name{
    color: var(--v-primary-base);
  }
}
</style>
